import { render, staticRenderFns } from "./Navbar.vue?vue&type=template&id=87c63166&scoped=true&"
import script from "./Navbar.vue?vue&type=script&lang=js&"
export * from "./Navbar.vue?vue&type=script&lang=js&"
import style0 from "./Navbar.vue?vue&type=style&index=0&id=87c63166&prod&scoped=true&lang=css&"
import style1 from "./Navbar.vue?vue&type=style&index=1&id=87c63166&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c63166",
  null
  
)

export default component.exports